import React, {useState} from "react";
import "react-calendar/dist/Calendar.css";

import Calendar from "react-calendar";

import {monthNames, shortWeekdayLabels} from "../index";
import {useAppDispatch} from "../../../../../../../common/hook";
import {setToDate, setToDateNew} from "../../../../../../../app/expense-date-reduser";
import {format} from "date-fns";

export const CalendarTo = ({onClose}: { onClose: () => void }) => {
    const [date, setDate] = useState<Date>(new Date());
    const dispatch = useAppDispatch();

    const onDateChange = (value: any) => {
        const formattedDate = format(value, 'dd/MM/yyyy');
        const day = value.getDate();
        const monthIndex = value.getMonth();
        const year = value.getFullYear();
        const formattedDateNew = `${day} ${monthNames[monthIndex]} ${year}`;


        onClose();
        if (formattedDate) {
            dispatch(setToDate(formattedDate));
        }
        if (formattedDateNew) {
            dispatch(setToDateNew(formattedDateNew));
        }
    };



    return (
        <div className="calendar-to">
            <Calendar
                locale="ru"
                onChange={onDateChange}
                value={date}
                view="month"
                formatShortWeekday={(locale, date) =>
                    shortWeekdayLabels.weekdayShort[date.getDay()]
                }
                formatMonth={(locale, date) =>
                    new Intl.DateTimeFormat(locale, {month: "short"}).format(date)
                }
                calendarType="ISO 8601"
            />
        </div>
    );
};